// react
import { useContext, useState } from 'react';

// types
import { WithdrawalApplication } from '../../../@types';

// i18n
import { useTranslation } from 'react-i18next';

// context
import { ContextProject } from '../../pages/Project/Project.context';

// hooks
import { useFetch } from '../../../hooks/useFetch';

// fields
import { Select, SelectProps } from '../Select/Select';

export const SelectWithdrawalApplication = ({ ...props }: SelectProps) => {
	// session
	const accessToken = sessionStorage.getItem('accessToken');
	const idToken = sessionStorage.getItem('idToken');

	// hooks
	const { t } = useTranslation();

	// context
	const { project } = useContext(ContextProject);

	// state
	const [withdrawalApplications, setWithdrawalApplications] = useState<WithdrawalApplication[]>([]);

	// fetch withdrawal applications
	useFetch({
		isEnabled: Boolean(project?.id),
		url: `${process.env.REACT_APP_API_URL}/withdrawal-applications?project=${project?.id}&fields=id,idExternal`,
		options: {
			headers: {
				Authorization: `Bearer ${accessToken}`,
				User: String(idToken),
			},
		},
		onSuccess: (res) => {
			if (res.data) {
				setWithdrawalApplications(res.data);
			}
		},
	});

	const optionsWithdrawalApplications = withdrawalApplications.map((wa) => {
		return {
			label: wa.idExternal,
			value: String(wa.id),
		};
	});

	return (
		<Select
			label={t('withdrawalApplication')}
			name="withdrawalApplication"
			options={optionsWithdrawalApplications}
			{...props}
		/>
	);
};
